import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-benefitOrder",
  "use": "icon-benefitOrder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-benefitOrder\"><path d=\"M83.2 197.44v357.824q0 187.52 120.64 297.472 89.536 81.664 294.08 149.76a44.8 44.8 0 0 0 28.288 0q204.544-68.096 294.016-149.76Q940.8 742.848 940.8 555.456V197.44a44.8 44.8 0 0 0-32.256-43.008L524.8 42.304a44.8 44.8 0 0 0-25.088 0L115.456 154.432a44.8 44.8 0 0 0-32.256 43.008z m180.992 589.12Q172.8 703.168 172.8 555.264V231.04l339.392-99.008L851.2 231.04v324.352q0 147.84-91.392 231.168-72.512 66.176-247.744 126.144-175.296-59.968-247.872-126.144zM307.2 364.8h409.6V275.2H307.2v89.6z m0 170.688h409.6v-89.6H307.2v89.6z m0 170.624h281.6v-89.6H307.2v89.6z\" p-id=\"6655\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/benefitOrder.svg
// module id = 9tw0
// module chunks = 32